<!--  -->
<template>
  <div class="container">
    <!-- 年份选择器 -->
    <YearSelect
      :defaultValue="newYearData"
      :yearOptions="yearOptions"
      @changeYear="changeYear"
    ></YearSelect>
    <div class="model_box model_box_1">
      <div class="model_box_title">产品销售额</div>
      <div class="model_box_content">
        <div class="item">
          <Radius :data="allData.oneProportion"></Radius>
          <div class="value">{{ allData.one }}</div>
          <div class="name">招牌产品</div>
        </div>
        <div class="item">
          <Radius :data="allData.twoProportion"></Radius>
          <div class="value">{{ allData.two }}</div>
          <div class="name">活动产品</div>
        </div>
        <div class="item">
          <Radius :data="allData.threeProportion"></Radius>
          <div class="value">{{ allData.three }}</div>
          <div class="name">其他产品</div>
        </div>
      </div>
    </div>
    <div class="model_box model_box_2">
      <div class="model_box_title">支付方式</div>
      <div class="model_box_content">
        <JLYPieChart :data="allData.JLYpieData"></JLYPieChart>
        <div class="total">
          <div class="value">{{allData.totalCount}}</div>
          <div class="name">总数</div>
        </div>
        <div class="legend">
          <div class="item" v-for="v in allData.JLYpieData" :key="v.name">
            <div class="name">
              <span :style="{ background: v.color }"></span>{{ v.name }}
            </div>
            <div class="value">{{ v.value }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_box model_box_3">
      <div class="model_box_title">季度销售额</div>
      <div class="model_box_content">
        <div class="total">
          <img src="../../assets/imgs/home/person.png" alt="" />
          <span class="name">季度销售总数</span>
          <span class="value">{{allData.allQuarterCount}}</span>
        </div>
        <CPYBarChart :data="allData.CPYBarData"></CPYBarChart>
      </div>
    </div>
    <div class="model_box model_box_4">
      <div class="model_box_title">销售占比</div>
      <div class="model_box_content">
        <KYRYPieChart :data="allData.KYRYpieData"></KYRYPieChart>
        <div class="total">
          <div class="value">{{allData.allCount}}</div>
          <div class="name">总数</div>
        </div>
        <div class="legend">
          <div class="item" v-for="v in allData.KYRYpieData" :key="v.name">
            <div class="name">
              <span :style="{ background: v.color }"></span>{{ v.name }}
            </div>
            <div class="value">{{ v.value }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_box model_box_5">
      <div class="model_box_title">季度支出成本</div>
      <div class="model_box_content">
        <div class="total">
          <img src="../../assets/imgs/home/person.png" alt="" />
          <span class="name">季度支出成本总数</span>
          <span class="value">{{allData.ShzdyAllCount}}</span>
        </div>
        <SHTYZDYBarChart :data="allData.SHTYZDYBarData"></SHTYZDYBarChart>
      </div>
    </div>
    <div class="model_box model_box_6">
      <div class="model_box_title">员工性别比例以及支出方向</div>
      <div class="model_box_content">
        <div class="legend_box_1">
          <div class="item">
            <img src="../../assets/imgs/home/man.png" alt="" />
            <span class="name">男性</span>
            <span class="value">{{allData.tyglryAllNan}}</span>
          </div>
          <div class="item">
            <img src="../../assets/imgs/home/woman.png" alt="" />
            <span class="name">女性</span>
            <span class="value">{{allData.tyglryAllNv}}</span>
          </div>
        </div>
        <div class="legend_box_2">
          <div class="item" v-for="v in allData.TYGLRYpieData" :key="v.name">
            <div class="name">
              <span :style="{ background: v.color }"></span>{{ v.name }}
            </div>
            <div class="value">{{ v.value }}</div>
          </div>
        </div>
        <img class="pie_logo" src="../../assets/imgs/home/num.png" alt="" />
        <TYGLRYPieChart :data="allData.TYGLRYpieData"></TYGLRYPieChart>
      </div>
    </div>
    <!-- <div class="model_box model_box_5">
      <div class="model_box_title">职业技能人员</div>
      <div class="model_box_content">
        <div class="total">
          <img src="../../assets/imgs/home/person.png" alt="" />
          <span class="name">职业技能人员总数</span>
          <span class="value">{{athIetes.zyjnAllCount}}</span>
        </div>
        <SHTYZDYBarChart :data="ZYJNBarData"></SHTYZDYBarChart>
      </div>
    </div> -->
  </div>
</template>

<script>
import { screenAllCount } from '@/api/systemData';
// 教练员-饼图
import JLYPieChart from './echarts/JLYPieChart.vue'
// 科医人员-饼图
import KYRYPieChart from './echarts/KYRYPieChart.vue'
// 体育管理人员(在编)-饼图
import TYGLRYPieChart from './echarts/TYGLRYPieChart.vue'
// 裁判员-柱状图
import CPYBarChart from './echarts/CPYBarChart.vue'
// 社会体育指导员-柱状图
import SHTYZDYBarChart from './echarts/SHTYZDYBarChart.vue'
// 百分比圆环
import Radius from './echarts/Radius.vue'

// 接口数据
import { allCount } from '@/api/dataManage'
import { Message } from 'element-ui'
export default {
  components: {
    JLYPieChart,
    KYRYPieChart,
    TYGLRYPieChart,
    CPYBarChart,
    SHTYZDYBarChart,
    Radius,
  },
  data() {
    return {
      newYearData:'2023',
      // 年份选择器
      yearOptions: [
        {
          value: '2026',
          label: '2026年'
        },
        {
          value: '2025',
          label: '2025年'
        },
        {
          value: '2024',
          label: '2024年'
        },
        {
          value: '2023',
          label: '2023年',
        },
        {
          value: '2022',
          label: '2022年',
        },
        {
          value: '2021',
          label: '2021年',
        },
        {
          value: '2020',
          label: '2020年',
        },
        {
          value: '2019',
          label: '2019年',
        },
      ],
      JLYpieData: [
        // {
        //   name: '体育系统编制',
        //   value: 1400,
        //   color: '#34B3E4'
        // },
        // {
        //   name: '非体育系统编制',
        //   value: 2400,
        //   color: '#5ACB57'
        // }
      ],
      // colorMap:{
      //   1400:'#34B3E4',
      //   2400:"#5ACB57"
      // },
      KYRYpieData: [
        // {
        //   name: '科研人员',
        //   value: 1400,
        //   color: '#0075FF'
        // },
        // {
        //   name: '医务人员',
        //   value: 2400,
        //   color: '#5ACB57'
        // },
        // {
        //   name: '运动防护师',
        //   value: 2400,
        //   color: '#FABD21'
        // }
      ],
      CPYBarData: {
        // xData: ['国际级', '国家级', '一级'],
        // yData: [120, 200, 150]
      },
      SHTYZDYBarData: {
        // xData: ['国家级', '一级', '二级', '三级'],
        // yData: [120, 200, 150, 150]
      },
      ZYJNBarData:{

      },
      TYGLRYpieData: [
        // {
        //   name: '管理岗位人员',
        //   value: 400,
        //   color: '#0075FF',
        // },
        // {
        //   name: '专技岗位人员',
        //   value: 1400,
        //   color: '#5ACB57',
        // },
      ],
      // 运动员athIetes
      athIetes: {},
      newYearData: '2023',
      allData:{},
    }
  },
  computed: {},
  methods: {
    changeYear(val) {
      this.yearValue = val
      console.log('🚀 ~ changeYear ~ val:', val)
      this.newYearData = val;
      this.refreshList();
    },
    refreshList() {
      const pageForm = {
        // page: this.page,
        // pageSize: this.pageSize,
        // taskTypeId: this.taskTypeId,
        year: this.newYearData, 
      };
      let pageableForm = { ...pageForm};
      let year = this.newYearData
      screenAllCount({year})
        .then((res) => {
          console.log('res', res)
          if (res.code == 10000) {
            console.log("res",res);
            this.allData = res.data;
            return;
            //产品销售额
            






            this.athIetes = res.data
            // 教练员
            this.JLYpieData = res.data.JLYpieData
            // 裁判员
            this.CPYBarData = res.data.CPYBarData
            // 科医人员
            this.KYRYpieData = res.data.KYRYpieData
            //社会体育指导员
            this.SHTYZDYBarData = res.data.SHTYZDYBarData
            this.ZYJNBarData = res.data.ZYJNBarData
            // 体育管理人员(在编)
            this.TYGLRYpieData = res.data.TYGLRYpieData;
            console.log('this.athIetes', this.athIetes)
          } else {
            // Message(res.msg);

            Message({
              type: 'warning',
              message: res.msg,
            })
          }
        })
        .catch((error) => {
          console.log('catch', error)
        })
    },
  },
  created() {
    this.refreshList()
  },
  mounted() {},
  destroyed() {},
}
</script>
<style lang="less" scoped>
.container {
  background: linear-gradient(to bottom, #e4f1ff 0%, #f3f9ff 100%);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
  color: #3b4f6a;
  font-family: 'DingTalk';
}
.model_box {
  width: calc(33.3% - 10px);
  height: calc(50% - 7px);
  border: 1px solid #fff;
  box-shadow: 0px 0px 5px #fff;
  background: #ddeaf88d;
  border-radius: 5px;
  padding: 6px;
  .model_box_title {
    font-size: 16px;
    height: 70px;
    line-height: 60px;
    background: url('../../assets/imgs/home/title.png') no-repeat center;
    background-size: 100% 100%;
    padding-left: 50px;
  }
  .model_box_content {
    height: calc(100% - 70px);
    width: 100%;
  }
}
// 运动员
.model_box_1 {
  .model_box_content {
    padding: 0 30px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item {
      background: #ddecfa;
      height: calc(33.3% - 6px);
      display: flex;
      align-items: center;
      .value {
        font-size: 20px;
        width: 80px;
      }
      .name {
        font-size: 14px;
      }
    }
  }
}
// 教练员+科医人员
.model_box_2,
.model_box_4 {
  .model_box_content {
    position: relative;
    .total {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 50%;
      top: 35%;
      transform: translate(-50%, -50%);
      .name {
        font-size: 14px;
      }
      .value {
        font-size: 16px;
      }
    }
    .legend {
      height: 30%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .item {
        .name {
          font-size: 14px;
          position: relative;
          span {
            width: 8px;
            height: 8px;
            display: inline-block;
            position: absolute;
            left: -15px;
            top: 7px;
          }
        }
        .value {
          font-size: 16px;
        }
      }
    }
  }
}

// 裁判员
.model_box_3,
.model_box_5 {
  .model_box_content {
    .total {
      font-size: 13px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      height: 30px;
      position: relative;
      top: -5px;
      img {
        width: 40px;
        margin-right: 8px;
      }
      .value {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }
}

// 体育管理人员(在编)
.model_box_6 {
  .model_box_content {
    position: relative;
    .legend_box_1 {
      display: flex;
      justify-content: space-evenly;
      .item {
        font-size: 13px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        height: 30px;
        position: relative;
        top: -5px;
        img {
          width: 30px;
          margin-right: 8px;
        }
        .value {
          font-size: 16px;
          margin-left: 10px;
        }
      }
    }
    .legend_box_2 {
      height: calc(100% - 30px);
      width: 30%;
      position: absolute;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .item {
        .name {
          font-size: 14px;
          position: relative;
          span {
            width: 8px;
            height: 8px;
            display: inline-block;
            position: absolute;
            left: -15px;
            top: 7px;
          }
        }
        .value {
          font-size: 16px;
        }
      }
    }
    .pie_logo {
      position: absolute;
      width: 40px;
      left: 35%;
      top: calc(50% + 15px);
      transform: translate(-50%, -50%);
    }
  }
}
</style>
